import type { ISEOProps, TPageSEOKey } from "../types/core";
import { HomePageSEO } from "./home";
import { LoginPageSEO } from "./login";
import { RegisterPageSEO } from "./register";
import { ForgotPasswordPageSEO } from "./forgot-password";
import { ResetPasswordPageSEO } from "./reset-password";
import { ProfilePageSEO } from "./profile";
import { PostCreatorPageSEO } from "./post-creator";
import { LikedPostsPageSEO } from "./liked-posts";
import { BookmarkedPostsPageSEO } from "./bookmarked-posts";
import { MessagesPageSEO } from "./messages";
import { DashboardPageSEO } from "./dashboard";
import { AdminDashboardPageSEO } from "./admin-dashboard";
import { AdminPayoutsPageSEO } from "./admin-payouts";
import { AdminTaxFormsPageSEO } from "./admin-tax-forms";
import { SettingsPageSEO } from "./settings";
import { AgeProofsPageSEO } from "./age-proofs";
import { ChooseUserTypePageSEO } from "./choose-user-type";
import { SubscriptionsPageSEO } from "./subscriptions";
import { ReferralPageSEO } from "./referral";
import { EmailActivationPageSEO } from "./email-activation";
import { ComplaintsPolicyPageSEO } from "./complaints-policy";
import { TermsOfServicePageSEO } from "./terms-of-service";
import { PrivacyPolicyPageSEO } from "./privacy-policy";
import { RefundPolicyPageSEO } from "./refund-policy";
import { AcceptableUsePolicyPageSEO } from "./acceptable-use-policy";
import { DMCA_takedownPolicyPageSEO } from "./DMCA-takedown-policy";
import { ComplianceStatementPageSEO } from "./compliance-statement";
import { ContentProviderAgreementPageSEO } from "./content-provider-agreement";

export const pagesSEO: Record<TPageSEOKey, ISEOProps> = {
  home: HomePageSEO,
  login: LoginPageSEO,
  register: RegisterPageSEO,
  "forgot-password": ForgotPasswordPageSEO,
  "reset-password": ResetPasswordPageSEO,
  profile: ProfilePageSEO,
  "post-creator": PostCreatorPageSEO,
  "liked-posts": LikedPostsPageSEO,
  "bookmarked-posts": BookmarkedPostsPageSEO,
  messages: MessagesPageSEO,
  dashboard: DashboardPageSEO,
  "admin-dashboard": AdminDashboardPageSEO,
  "admin-payouts": AdminPayoutsPageSEO,
  "admin-tax-forms": AdminTaxFormsPageSEO,
  settings: SettingsPageSEO,
  "age-proofs": AgeProofsPageSEO,
  "choose-user-type": ChooseUserTypePageSEO,
  subscriptions: SubscriptionsPageSEO,
  referral: ReferralPageSEO,
  "email-activation": EmailActivationPageSEO,
  "complaints-policy": ComplaintsPolicyPageSEO,
  "terms-of-service": TermsOfServicePageSEO,
  "privacy-policy": PrivacyPolicyPageSEO,
  "refund-policy": RefundPolicyPageSEO,
  "acceptable-use-policy": AcceptableUsePolicyPageSEO,
  "DMCA-takedown-policy": DMCA_takedownPolicyPageSEO,
  "compliance-statement": ComplianceStatementPageSEO,
  "content-provider-agreement": ContentProviderAgreementPageSEO,
};
